import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createDetergent } from '@/apis/detergents'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateDetergentResponse } from '@/types/apis/detergents/CreateDetegentResponse'
import { CreateDetergentRequest } from '@/types/apis/detergents/CreateDetergentRequest'

export const useCreateDetergent = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateDetergentResponse>()

  const create = useCallback(
    async (request: CreateDetergentRequest) => {
      try {
        setLoading(true)
        const res = await createDetergent(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        navigate(routes.detergents.path)
      } catch (err) {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createDetergent: create,
    response,
  }
}
